import React from 'react'
import PropTypes from 'prop-types'
import { prismicHelpers } from '../../helpers'
import Link from '../core/Link'

/**
* Announcement banner underneath the main navbar
* that displays the prioritized prismic header announcement
* @param {object} announcements Array of Prismic announcments
* @returns {function} Component
*/
const AnnouncementBanner = ({ announcements }) => {
  /**
  * Filters announcements that are available to the user and visible.
  */
  const filteredAnnouncements =
    announcements.filter(announcement => prismicHelpers.userHasPermission(announcement))
    .filter(announcement => prismicHelpers.currentlyVisible(announcement))

  if (!filteredAnnouncements.length || !filteredAnnouncements[0].content) {
    return false
  }

  return (
    <div className="announcement-banner">
      <div className="banner-content">
        {!!filteredAnnouncements[0].link && (
          <Link linkRef="announcement-banner-clicked" href={filteredAnnouncements[0].link}>
            <div dangerouslySetInnerHTML={{__html: filteredAnnouncements[0].content}} />
          </Link>
        )}
        {!filteredAnnouncements[0].link && (
          <div dangerouslySetInnerHTML={{__html: filteredAnnouncements[0].content}} />
        )}
      </div>
    </div>
  )
}

AnnouncementBanner.propTypes = {
  announcements: PropTypes.arrayOf(PropTypes.shape({})),
}

AnnouncementBanner.defaultProps = {
  announcements: [],
}

export default AnnouncementBanner
